
import { ref, defineComponent, computed } from '@nuxtjs/composition-api';
import { onClickOutside } from '@vueuse/core';
import CategoryFilter from '~/domains/category/components/CategoryFilter';

export default defineComponent({
  name: 'CategoryCatalogSidebar',
  components: { CategoryFilter },
  props: {
    isOpenSidebar: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    selectedFilters: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const modal = ref(null);

    const isSelectedFilters = computed(() =>
      Object.values(props.selectedFilters).some((arr) => arr.length)
    );

    onClickOutside(modal, () => {
      if (props.isOpenSidebar) {
        emit('closeSidebar');
      }
    });

    return {
      modal,
      isSelectedFilters,
    };
  },
});
